import { IconProps } from "@stone-payments/jade";

function getSocialInfo(
  platform: "instagram" | "facebook" | "x" | "tiktok",
  username: string
) {
  switch (platform) {
    case "instagram":
      return {
        label: "Instagram",
        icon: "brand-instagram" as IconProps["use"],
        href: `https://instagram.com/${username}`,
        value: `@${username}`,
      };
    case "facebook":
      return {
        label: "Facebook",
        icon: "brand-facebook" as IconProps["use"],
        href: `https://facebook.com/${username}`,
        value: username,
      };
    case "x":
      return {
        label: "Twitter (X)",
        icon: "brand-x" as IconProps["use"],
        href: `https://x.com/${username}`,
        value: `@${username}`,
      };
    case "tiktok":
      return {
        label: "TikTok",
        icon: "brand-tiktok" as IconProps["use"],
        href: `https://tiktok.com/@${username}`,
        value: `@${username}`,
      };
  }
}

export { getSocialInfo };
